import styled from 'styled-components';
import { getFromTheme } from 'src/utils/styles';
import Card from 'src/components/Card';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;

  @media screen and (min-width: ${getFromTheme('breakpoint.sm')}) {
    width: 540px;
  }
  @media screen and (min-width: ${getFromTheme('breakpoint.md')}) {
    width: 720px;
    padding: 0 30px;
  }
  @media screen and (min-width: ${getFromTheme('breakpoint.lg')}) {
    width: 960px;
  }
  @media screen and (min-width: ${getFromTheme('breakpoint.xl')}) {
    width: 1140px;
  }
  @media screen and (min-width: ${getFromTheme('breakpoint.xxl')}) {
    width: 1320px;
  }
  @media screen and (min-width: ${getFromTheme('breakpoint.xxxl')}) {
    width: 1440px;
  }
`;

export const StyledBgCurve = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: -1;
`;

export const StyledFooterCopyright = styled.div`
  display: flex;
  flex-direction: column;

  & > span {
    color: var(--gray);
    font-size: 11px;
    font-weight: 300;
    line-height: 24px;
    text-align: center;
  }

  @media screen and (min-width: ${getFromTheme('breakpoint.lg')}) {
    display: block;
    flex-direction: initial;
    text-align: right;

    & > span {
      font-size: 13px;
      margin-right: 25px;
      text-align: left;
    }
  }
`;

export const StyledFooterInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: ${getFromTheme('breakpoint.md')}) {
    justify-content: flex-end;
  }
`;

export const StyledFooter = styled.footer`
  background-color: var(--white);
  border-top: 1px solid var(--light);
  padding: 34px 0;
  margin-top: 30px;

  @media screen and (min-width: ${getFromTheme('breakpoint.md')}) {
    margin-top: 103px;
  }
`;

export const StyledMain = styled.main`
  --heading-height: 99px;
  --main-margin-top: 30px;
  --header-height: 196px;

  @media screen and (min-width: ${getFromTheme('breakpoint.sm')}) {
    --main-margin-top: 40px;
  }

  @media screen and (min-width: ${getFromTheme('breakpoint.xl')}) {
    --main-margin-top: 16px;
  }

  margin-top: var(--main-margin-top);
  min-height: calc(100vh - var(--heading-height) - var(--main-margin-top) - var(--header-height));
`;

export const StyledHeaderInnerContainer = styled.div`
  padding: 15px 0;

  @media screen and (min-width: ${getFromTheme('breakpoint.md')}) {
    padding: 30px 0;
  }
`;

export const FormWrapperCard = styled(Card)`
  padding: calc(var(--padding-base) * 1.5) var(--padding-base);
  max-width: 715px;
  margin: 0 auto 30px;

  h2 {
    line-height: 1;
  }
  h3 {
    margin-bottom: calc(var(--margin-base) / 2);
  }

  @media screen and (min-width: ${getFromTheme('breakpoint.md')}) {
    padding: 53px 75px;
    margin-bottom: 47px;
  }
`;
